module.exports = __webpack_public_path__ + "static/media/font_regular.f2920329.woff2";